import { InAppMessagePresentationContext } from "../../../present/presentation/InAppMessagePresentationContext"
import { InAppMessageViewFactory } from "./InAppMessageViewFactory"

export class InAppMessageViewFactories {
  constructor(private readonly factories: InAppMessageViewFactory[]) {}

  get(context: InAppMessagePresentationContext): InAppMessageViewFactory | null {
    return this.factories.find((factory) => factory.supports(context)) ?? null
  }
}
